import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'
import Sidebar from './Sidebar'
import Loader from './Loader'
import { useLocation } from 'react-router-dom';

export default function Wrapper({ children, is_loader }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation();
  // Map pathnames to page_name values used in GlobalSidebar
  const pathToPageName = (pathname) => {
    if (pathname.startsWith('/dashboard') || pathname === '/') return 'dashboard';
    if (pathname.startsWith('/members')) return 'members';
    if (pathname.startsWith('/manage-members')) return 'manage-members';
    if (pathname.startsWith('/gallery')) return 'gallery';
    if (pathname.startsWith('/executive-committee')) return 'executive-committee';
    if (pathname.startsWith('/contacts')) return 'contacts';
    if (pathname.startsWith('/homepage')) return 'homepage';
    if (pathname.startsWith('/about')) return 'about';
    if (pathname.startsWith('/pending-subscriptions')) return 'pending-subscriptions';
    if (pathname.startsWith('/social-media-posting')) return 'social-media-posting';
    if (pathname.startsWith('/announcement')) return 'announcement';
    if (pathname.startsWith('/bulk-email')) return 'bulk-email';
    return '';
  };
  const page_name = pathToPageName(location.pathname);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  return (
    <>
      <Loader is_loader={is_loader} />
      {/* <div class="container-scroller"> */}
      {/* <div class=""> */}
      <div className="d-flex w-100">
        {/* <div class="container-fluid page-body-wrapper"> */}
        {/* <div class=""> */}
        {isSidebarOpen && <div style={{ width: '260px', flexShrink: 0 }}><Sidebar page_name={page_name} isFixed={false} /></div>}
        <div class="wrapper d-flex flex-column min-vh-100 flex-grow-1">
          <Header toggleSidebar={toggleSidebar} />
          <div class="body flex-grow-1 content-wrapper">
            {children}
          </div>
          <Footer />
        </div>
        {/* </div> */}
        {/* </div> */}
      </div>
    </>
  )
}
